var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"HomePage"}},[_c('div',{staticClass:"nav-bar"}),_vm._v(" "),_c('el-row',{staticClass:"banner-row",attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"banner-col",attrs:{"lg":16,"xs":24,"sm":22,"md":18}},[_c('div',{staticClass:"banner-col-left"},[_c('router-view')],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63fa560a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/HomePage.vue
// module id = null
// module chunks = 